import * as Sentry from "@sentry/vue";

export const initSentry = (Vue, router) => {
  const dsn = process.env.VUE_APP_SENTRY_DSN || "";

  if (dsn) {
    Sentry.init({
      Vue,
      dsn: dsn,
      integrations: [
        Sentry.browserTracingIntegration({ router })
      ],
      // Ajuste o sample rate conforme a necessidade de volume de dados
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        "localhost", "app.espasmos.gcodetec.com", "app.meli.gcodetec.com",
        "meli.app.br", "my.meli.app.br", "go.meli.app.br", "hub.meli.app.br",
        /^\//
      ],
      logErrors: true,
      sendDefaultPii: true
    });
  }
};
